import { useCallback, useState } from 'react';
import {
  finishTotpEnrollment,
  getMfaStatus,
  startTotpEnrollment,
} from './authSession';

type TotpSession = { secretKey: string; qrCodeUrl: string; secret: unknown };

export function useTotpEnrollment() {
  const [enrollment, setEnrollment] = useState<TotpSession | null>(null);
  const [code, setCode] = useState('');

  const isMfaEnrolled = useCallback(async () => {
    const status = await getMfaStatus();
    return status.enrolled;
  }, []);

  const start = useCallback(async () => {
    const session = await startTotpEnrollment();
    setEnrollment(session);
    setCode('');
    return session;
  }, []);

  const finish = useCallback(async () => {
    if (!enrollment) throw new Error('No MFA enrollment in progress');
    const status = await finishTotpEnrollment(code.trim(), enrollment);
    setEnrollment(null);
    setCode('');
    return status;
  }, [enrollment, code]);

  const cancel = useCallback(() => {
    setEnrollment(null);
    setCode('');
  }, []);

  return { enrollment, code, setCode, start, finish, cancel, isMfaEnrolled };
}
